<template>
  <div id="downloads" class="column is-12">
    <div class="columns is-multiline is-variable is-2">
      <div class="column is-6" v-if="themeList.length">
        <content-block
          :content="{ Title: $t('Downloads.Articles'), Subtitle: false }"
        >
          <ul>
            <li v-for="(theme, idx) in themeList" :key="idx">
              <a
                :href="
                  '/' + theme.DownloadPdf + '?v=' + +new Date(theme.StartMoment)
                "
                @click.prevent="downloadHref($event.target, theme.Title)"
                target="_blank"
              >
                <font-awesome-icon :icon="icons.pdf" />
                <span>{{ theme.Title }}</span>
              </a>
            </li>
          </ul>
        </content-block>
      </div>
      <div
        :class="{
          'is-6 column': themeList.length,
          'columns is-multiline is-variable is-2': !themeList.length,
        }"
      >
        <content-block
          v-for="(group, key) in downloadList"
          :key="key"
          :content="{ Title: getGroupName(key), Subtitle: false }"
          :className="!themeList.length ? 'is-6 column' : ''"
        >
          <p v-if="getGroupDescription(key)">{{ getGroupDescription(key) }}</p>
          <ul>
            <li v-for="(download, i) in group" :key="i">
              <a
                :href="$store.state.imgBase + download.Filename"
                @click.prevent="downloadHref($event.target, download.Title)"
                target="_blank"
              >
                <div class="columns is-gapless is-vcentered">
                  <div class="column is-narrow">
                    <font-awesome-icon :icon="getIcon(download)" />
                  </div>
                  <div class="column">
                    <span
                      >{{ download.Title
                      }}<small v-if="download.Description != ''">{{
                        download.Description
                      }}</small></span
                    >
                  </div>
                  <div class="column is-narrow">
                    <span class="has-text-grey-light">{{
                      printHumanSize(download)
                    }}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </content-block>
      </div>
    </div>
  </div>
</template>

<script>
import contentBlock from '@/components/Block.vue'
import {
  faFilePdf,
  faFileCsv,
  faFileWord,
  faFile,
  faFileImage,
  faFileVideo,
  faFileArchive
} from '@fortawesome/pro-solid-svg-icons'

import { appInsights } from '@/insights'

export default {
  name: 'downloadsList',
  data () {
    return {
      themes: [],
      themeTimestamp: '',
      icons: {
        png: faFileImage,
        jpg: faFileImage,
        jpeg: faFileImage,
        pdf: faFilePdf,
        xls: faFileCsv,
        xlsx: faFileCsv,
        doc: faFileWord,
        docx: faFileWord,
        default: faFile,
        mp4: faFileVideo,
        zip: faFileArchive
      }
    }
  },
  components: {
    contentBlock
  },
  computed: {
    themeList () {
      var self = this
      var tmp = []
      if (self.$store.state.themes.length > 0) {
        self.$store.state.themes.forEach((theme) => {
          if (self.$store.state.language === theme.Culture) {
            tmp.push(theme)
          }
        })
      }
      return tmp
    },
    downloadList () {
      var self = this
      var tmp = {}
      if (self.$store.state.downloads.length > 0) {
        self.$store.state.downloads.forEach((download) => {
          if (
            self.$store.state.language === download.Culture &&
            Number(download.GroupId) !== -1
          ) {
            if (!tmp.hasOwnProperty(download.GroupId)) {
              tmp[download.GroupId] = []
            }
            tmp[download.GroupId].push(download)
          }
        })
      }
      return tmp
    }
  },
  methods: {
    downloadHref: function ($el, name) {
      var href = $el.closest('a[href]').href
      appInsights.trackEvent({
        name: 'Download',
        properties: {
          file: name
        }
      })
      if (href) {
        window.open(href, '_blank')
      }
    },
    getIcon: function (download) {
      var extension = download.Filename.split('.').reverse()[0]
      if (this.icons.hasOwnProperty(extension)) {
        return this.icons[extension]
      } else {
        return this.icons.default
      }
    },
    getGroupName: function (id) {
      var self = this
      var name = ''

      self.$store.state.downloadGroups.forEach((group) => {
        if (group.ID === Number(id)) {
          name = group.Cultures[self.$store.state.language].Title
        }
      })
      return name
    },
    getGroupDescription: function (id) {
      var self = this
      var description = ''

      self.$store.state.downloadGroups.forEach((group) => {
        if (group.ID === Number(id)) {
          description = group.Cultures[self.$store.state.language].Description
        }
      })
      return description
    },
    setLists: function () {
      var self = this

      // self.groups = self.$store.state.downloads
      self.$store.dispatch('getThemes', false).then(function () {
        self.themes = self.$store.state.themes
      })
      // self.$store.dispatch('getDownloadGroups')
      // self.$store.dispatch('getDownloads').then(function () {
      //   self.groups = self.$store.state.downloads
      //   // var tmp = {}
      //   // self.$store.state.downloads.forEach(download => {
      //   //   if (!tmp.hasOwnProperty(download.GroupId)) {
      //   //     tmp[download.GroupId] = []
      //   //   }
      //   //   tmp[download.GroupId].push(download)
      //   // })
      //   // self.groups = tmp
      // })
    },
    printHumanSize (file) {
      var size = file && file.FileSize > 0 ? file.FileSize : false
      var i =
        !size || size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
      var result =
        i === 0 && !size
          ? '-'
          : (size / Math.pow(1024, i)).toFixed(i < 2 ? 0 : 2) * 1 +
            ' ' +
            ['B', 'kB', 'MB', 'GB', 'TB'][i]
      return result
    }
  },
  mounted () {
    var self = this
    self.setLists()
  },
  watch: {
    '$store.state.isAdmin': {
      handler: function (val) {
        var self = this
        self.$store.commit('setThemes', [])
        // self.$store.commit('setDownloads', [])
        self.setLists()
      },
      immediate: false
    }
    // '$store.state.themes': {
    //   handler: function (val) {
    //     this.themeTimestamp = val.StartMoment
    //   },
    //   immediate: true,
    //   deep: true
    // }
  }
}
</script>

<style lang="scss" scoped>
#downloads {
  /deep/.panel {
    .panel-block.content {
      ul {
        list-style-type: none;
        margin: 0;

        li {
          border-bottom: 2px solid #dde1e3;
          overflow: hidden;
          padding: 10px 0;
          a {
            display: block;
            span {
              // display: inline-block;
              // width: calc(100% - 100px);
              font-size: 14px;
              color: $text;
              line-height: 20px;
              small {
                display: block;
              }
            }
            span:last-of-type {
              // display: inline-block;
              // width: 60px;
              // color: $grey-light;
              // font-size: 12px;
              // vertical-align: top;
              // text-align: right;
            }
            svg {
              vertical-align: top;
              margin-top: 5px;
              color: $danger;
              width: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
